export const SubscriptionPricingFormName = 'subscription-pricing';

export enum SubscriptionPricingFormFields {
  Pricing = 'pricing',
}
